import { GET_MC_ANSWER, REMOVE_CURRENT_MC_ANSWER} from '../actions/mcAnswersActions';

/**
 * Manejo de la parte del estado correspondiente a la respuesta de opcion multiple actual.
 * Permite la actualización de la respuesta actual y eliminar la misma.
 *
 * @export
 * @param {*} [state={}] : estado de la aplicación
 * @param {*} action : operación a realizar sobre el estado (correspondiente a la respuesta actual)
 * @returns El estado con la modificación/acción realizada.
 */
export default function (state = null, action) {
  switch (action.type) {
    case GET_MC_ANSWER:
      return action.payload;
    case REMOVE_CURRENT_MC_ANSWER:
      return null;
    default:
      return state;
  }
}
